import { tokens } from './tokens';

/**
 * Visual tokens of the charts. One color for data (petrol); amber only for
 * overshoot and what is due. A category's identity comes from its label,
 * never from a color of its own.
 */
export const chart = {
  primary: tokens.accent,
  primarySoft: tokens.accentHatch,
  primaryFill: 'rgba(15,118,110,0.10)',
  spend: tokens.warn,
  ok: tokens.accent,
  track: tokens.line,
  grid: tokens.line,
  ink: tokens.ink,
  inkSecondary: tokens.ink2,
  inkMuted: tokens.ink3,
  surface: tokens.surface,
} as const;

export const axisTick = { fontSize: 11, fill: chart.inkMuted } as const;

/** Whole-unit money in the user's currency: "R$ 1.532", "$1,532". */
export const formatMoney = (value: number, currency: string, locale: string): string =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);

/** Money to the cent, for lists of single items: "R$ 230,00". */
export const formatMoneyCents = (value: number, currency: string, locale: string): string =>
  new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);

/**
 * Axis-short numbers: 1532 → "1,5 mil" (pt/es) or "1.5k" (en); 850 → "850".
 * The space is non-breaking: Recharts wraps SVG labels at spaces when the
 * bar under them is narrow, which split "2,1 mil" over two lines.
 */
export const formatShort = (value: number, locale: string): string => {
  if (Math.abs(value) < 1000) {
    return String(Math.round(value));
  }
  const thousands = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value / 1000);
  return locale.startsWith('en') ? `${thousands}k` : `${thousands}\u00a0mil`;
};
